export default {
  clean: () => import("/opt/app-root/src/website/layouts/clean.vue").then(m => m.default || m),
  default: () => import("/opt/app-root/src/website/layouts/default.vue").then(m => m.default || m),
  "footer-only": () => import("/opt/app-root/src/website/layouts/footer-only.vue").then(m => m.default || m)
}